var cov_174x570h2p = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DataList/index.ts",
      hash = "335bf4b87dd85feaaa93f9c9c96fc6c63cbecaa9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DataList/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 37
        },
        end: {
          line: 8,
          column: 94
        }
      },
      "1": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 17,
          column: 8
        }
      },
      "2": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 24
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { compose } from '../utils/func';
import Datum from '../Datum';
import DList from './List';
import BaseItem from './BaseItem';
import Pagination from './Pagination';
var bindKeys = (cov_174x570h2p.s[0]++, ['disabled', 'limit', 'format', 'prediction', 'distinct']);
var List = (cov_174x570h2p.s[1]++, compose(Datum.hoc({
  bindProps: bindKeys,
  ignoreUndefined: true,
  setValueType: null,
  pure: false
}), Pagination)(DList));
cov_174x570h2p.s[2]++;
List.BaseItem = BaseItem;
export default List;